var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikedCarousel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "22px",
    viewBox: "0 0 25 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikedCarousel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.0151185,1.92303424 C3.1940685,0.703732235 4.7441685,0.0932548235 6.2963685,0.0932548235 C7.8485685,0.0932548235 9.4064685,0.703734706 10.5854435,1.92303424 L11.9994935,3.389946 L13.4135685,1.93075482 C15.7714935,-0.507896118 19.625969,-0.507841765 21.983869,1.93075482 C24.341794,4.36935388 24.341794,8.28590082 21.983869,10.7245024 C18.775044,14.0431447 15.5676685,17.3654929 12.3588685,20.6840612 C12.2644193,20.7827354 12.133036,20.8386414 11.9955935,20.8386414 C11.858151,20.8386414 11.7267677,20.7827354 11.6323185,20.6840612 L2.0151185,10.7167694 C-0.340106427,8.27628035 -0.342806427,4.36159376 2.0151185,1.92303424 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Heart-Match-Green",
    transform: "translate(0.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/light-green",
    transform: "translate(0.500000, 2.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7EC34D",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikedCarousel);
export default __webpack_public_path__ + "static/media/icLikedCarousel.9642715157545e6f1c5263dea28da775.svg";
export { ForwardRef as ReactComponent };